import { render, staticRenderFns } from "./translations.vue?vue&type=template&id=443bdf0c&scoped=true&"
import script from "./translations.vue?vue&type=script&lang=js&"
export * from "./translations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443bdf0c",
  null
  
)

export default component.exports